import React from "react";
import { NavLink } from "react-router-dom";
import Menu from './Menu/Menu';
import Logo from "./Logo/Logo";
import DT_top_full from 'assets/img/DT-top-full.png';
import DT_top_mobile from 'assets/img/DT-top-mobile.png';
import './Header.css';

const header = () => {
  return (
    <div className="top">
      <Logo />
      <div className="top-right">
        <div className="band-name">
          <NavLink to="/" key="Hlavní stránka">
            <img className="band-name-desktop" src={DT_top_full} alt="kapela Doktor Triceratops" />
          </NavLink>
          <NavLink to="/" key="Hlavní stránka (mobilní)">
            <img className="band-name-mobile" src={DT_top_mobile} alt="kapela Doktor Triceratops" />
          </NavLink>
        </div>
        <div className="metal-music">
          <span className="line"></span>
          Old skull metal
          <span className="line"></span>
        </div>
        <Menu />
      </div>
    </div>
  );
};

export default header;